import { AnyAction } from 'redux';
import { ActionTypes, ProjectsState } from 'store/project/types/state.types';

const initialState: ProjectsState = {
  list: [],
  loading: false,
  users: [],
};

const projectsReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: ProjectsState = initialState,
  { type, payload }: AnyAction,
): ProjectsState => {
  switch (type) {
    case ActionTypes.SET_LIST:
      return { ...state, list: payload };
    case ActionTypes.SET_LIST_LOADING:
      return { ...state, loading: payload };
    case ActionTypes.SET_USERS:
      return { ...state, users: payload };
    default:
      return state;
  }
};

export default projectsReducer;
